let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("7uTJ4")).then(() => parcelRequire('dh9Op'));